import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { ChargePointTypes } from './Actions'
import RequestState from 'Enums/RequestState'
import history from 'history/browser'
import IFFilterType from 'Enums/IFFilterType'
import InfinityEnums from 'Enums/InfinityEnums'
import { filterBestMatch } from '../../Utils/SortFunctions'
import {
  chargePointStatisticsFilter,
  chargingSessionLogsFilter,
  getDefaultChargePointStatisticsFilter,
} from 'Constants/Filters'

export const fetchChargePointListLoading = (state) => {
  return {
    ...state,
    fetchChargePointListRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointListSuccess = (
  state,
  { chargePoints, stationsFilter },
) => {
  let currentPath = history.location.pathname
  const index = currentPath.indexOf('station')
  let chargePointIndex = 0

  if (index !== -1) {
    const slashArray = history.location.pathname.split('/')
    const chargePointId = slashArray[slashArray.length - 1]

    chargePointIndex = chargePoints.findIndex(
      (chargePoint) => chargePointId === chargePoint._id,
    )
  }

  if (stationsFilter) {
    let isEmpty = true
    for (const filter of stationsFilter) {
      if (filter.value.length !== 0) {
        isEmpty = false
        break
      }
    }

    if (!isEmpty && chargePoints.length > 1) {
      chargePointIndex = filterBestMatch(stationsFilter, chargePoints)
    }
  }

  return {
    ...state,
    chargePoints: [...chargePoints],
    fetchChargePointListRequestState: RequestState.SUCCEEDED,
    selectedIndex: chargePoints.length !== 0 ? chargePointIndex : null,
  }
}

export const fetchChargePointListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointListRequestState: requestState,
  }
}

export const fetchChargePointLoading = (state) => {
  return {
    ...state,
    fetchChargePointRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointSuccess = (state, { chargePoint }) => {
  let newChargePoints = state.chargePoints
  let index = newChargePoints.findIndex((cp) => cp._id === chargePoint._id)
  if (index !== -1) {
    newChargePoints[index] = chargePoint
  }
  return {
    ...state,
    fetchChargePointRequestState: RequestState.SUCCEEDED,
    chargePoints: [...newChargePoints],
  }
}

export const fetchChargePointFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointRequestState: requestState,
  }
}
export const clearChargePoints = (state) => {
  return {
    ...state,
    chargePoints: [],
  }
}

export const setChargePointSelectedIndex = (state, { index }) => {
  return {
    ...state,
    selectedIndex: index,
  }
}

export const resetChargePointState = (state) => {
  return {
    ...state,
    chargePointLogPaginationOffset: 0,
    chargePointTransactionPaginationOffset: 0,
    fetchChargePointListRequestState: RequestState.UNINITIALIZED,
    fetchChargePointRequestState: RequestState.UNINITIALIZED,
    updateChargePointRequestState: RequestState.UNINITIALIZED,
    fetchChargePointLogListRequestState: RequestState.UNINITIALIZED,
    fetchChargePointTransactionListRequestState: RequestState.UNINITIALIZED,
    fetchChargePointConfigListRequestState: RequestState.UNINITIALIZED,
    updateChargePointConfigRequestState: RequestState.UNINITIALIZED,
    deleteChargePointRequestState: RequestState.UNINITIALIZED,
    addChargePointRequestState: RequestState.UNINITIALIZED,
    resetChargePointRequestState: RequestState.UNINITIALIZED,
    moveChargePointRequestState: RequestState.UNINITIALIZED,
    deleteMovedChargePointRequestState: RequestState.UNINITIALIZED,
    deleteChargePointTariffsRequestState: RequestState.UNINITIALIZED,
    addChargePointTariffsRequestState: RequestState.UNINITIALIZED,
    chargePointUploadDiagnostics: [],
  }
}

export const setChargePointLogPaginationOffset = (state, { offset }) => {
  return {
    ...state,
    chargePointLogPaginationOffset: offset,
  }
}

export const setChargePointTransactionPaginationOffset = (
  state,
  { offset },
) => {
  return {
    ...state,
    chargePointTransactionPaginationOffset: offset,
  }
}

export const updateChargePointLoading = (state) => {
  return {
    ...state,
    updateChargePointRequestState: RequestState.LOADING,
  }
}

export const updateChargePointSuccess = (
  state,
  { index, updatedChargePoint },
) => {
  let newChargePoints = [...state.chargePoints]
  newChargePoints[index] = updatedChargePoint
  return {
    ...state,
    chargePoints: newChargePoints,
    updateChargePointRequestState: RequestState.SUCCEEDED,
  }
}

export const updateChargePointFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    updateChargePointRequestState: requestState,
  }
}

export const moveChargePointLoading = (state) => {
  return {
    ...state,
    moveChargePointRequestState: RequestState.LOADING,
  }
}

export const moveChargePointSuccess = (
  state,
  { index, updatedChargePoint },
) => {
  return {
    ...state,
    moveChargePointRequestState: RequestState.SUCCEEDED,
  }
}

export const moveChargePointFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    moveChargePointRequestState: requestState,
  }
}

export const fetchChargePointLogListLoading = (state) => {
  return {
    ...state,
    fetchChargePointLogListRequestState: RequestState.LOADING,
  }
}

export const prependChargePointLogList = (state, { chargePointLogs }) => {
  let appendCount = 0
  let tempLogs = []
  for (let chargePointLog of chargePointLogs) {
    tempLogs.push(chargePointLog)
    if (chargePointLog.requestMessage) appendCount++
    if (chargePointLog.responseMessage) appendCount++
  }
  if (tempLogs.length > 1) tempLogs = tempLogs.reverse()
  return {
    ...state,
    chargePointLogs: [...tempLogs, ...state.chargePointLogs],
    chargePointLogsFirstItemIndex:
      state.chargePointLogsFirstItemIndex - appendCount,
    bufferedChargePointLogs: [],
  }
}

export const appendBufferChargePointLogList = (state, { chargePointLogs }) => {
  return {
    ...state,
    bufferedChargePointLogs: [
      ...chargePointLogs,
      ...state.bufferedChargePointLogs,
    ],
  }
}

export const fetchChargePointLogListSuccess = (
  state,
  { offset, chargePointLogs, nextOffset },
) => {
  let result = []
  for (let j = 0; j < chargePointLogs.length; j++) {
    if (
      !state.chargePointLogs.some(
        (chargePointLog) => chargePointLog._id === chargePointLogs[j]._id,
      )
    ) {
      result.push(chargePointLogs[j])
    }
  }
  if (offset === 0) {
    return {
      ...state,
      chargePointLogs: [...chargePointLogs],
      chargePointLogPaginationOffset: nextOffset,
      fetchChargePointLogListRequestState: RequestState.SUCCEEDED,
    }
  } else {
    return {
      ...state,
      chargePointLogs: [...state.chargePointLogs, ...result],
      chargePointLogPaginationOffset: nextOffset,
      fetchChargePointLogListRequestState: RequestState.SUCCEEDED,
    }
  }
}

export const fetchChargePointLogListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointLogListRequestState: requestState,
  }
}

export const clearChargePointLogs = (state) => {
  return {
    ...state,
    chargePointLogs: [],
    chargePointLogsFirstItemIndex: 1000000,
    fetchChargePointLogListRequestState: RequestState.UNINITIALIZED,
  }
}

export const setChargePointLogsFilter = (state, { newFilter }) => {
  return {
    ...state,
    chargePointLogFilter: newFilter,
  }
}

export const fetchChargePointTransactionListLoading = (state) => {
  return {
    ...state,
    fetchChargePointTransactionListRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointTransactionListSuccess = (
  state,
  { offset, chargePointTransactions, nextOffset },
) => {
  let result = []
  for (let j = 0; j < chargePointTransactions.length; j++) {
    if (
      !state.chargePointTransactions.some(
        (chargePointTransaction) =>
          chargePointTransaction._id === chargePointTransactions[j]._id,
      )
    ) {
      result.push(chargePointTransactions[j])
    }
  }
  if (offset === 0) {
    return {
      ...state,
      chargePointTransactions: [...chargePointTransactions],
      chargePointTransactionPaginationOffset: nextOffset,
      fetchChargePointTransactionListRequestState: RequestState.SUCCEEDED,
    }
  } else {
    return {
      ...state,
      chargePointTransactions: [...state.chargePointTransactions, ...result],
      chargePointTransactionPaginationOffset: nextOffset,
      fetchChargePointTransactionListRequestState: RequestState.SUCCEEDED,
    }
  }
}

export const fetchChargePointTransactionListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointTransactionListRequestState: requestState,
  }
}

export const clearChargePointTransactions = (state) => {
  return {
    ...state,
    chargePointTransactions: [],
    fetchChargePointTransactionListRequestState: RequestState.UNINITIALIZED,
  }
}

export const setChargePointTransactionsFilter = (state, { newFilter }) => {
  return {
    ...state,
    chargePointTransactionFilter: newFilter,
  }
}

export const fetchChargePointConfigListLoading = (state) => {
  return {
    ...state,
    fetchChargePointConfigListRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointConfigListSuccess = (state, { data }) => {
  return {
    ...state,
    chargePointConfigs: { ...data.configs },
    chargePointConfigsLastUpdated: data.updatedAt,
    fetchChargePointConfigListRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointConfigListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    chargePointConfigs: error?.data?.configs ? { ...error?.data?.configs } : {},
    chargePointConfigsLastUpdated: error?.data?.updatedAt
      ? error?.data?.updatedAt
      : '',
    fetchChargePointConfigListRequestState: requestState,
  }
}

export const clearChargePointConfigs = (state) => {
  return {
    ...state,
    chargePointConfigs: [],
  }
}

export const setChargePointFilterText = (state, { filter }) => {
  return {
    ...state,
    chargePointFilterText: filter,
  }
}

export const updateChargePointConfigLoading = (state) => {
  return {
    ...state,
    updateChargePointConfigRequestState: RequestState.LOADING,
  }
}

export const updateChargePointConfigSuccess = (state, { key, value }) => {
  let newConfigList = state.chargePointConfigs
  newConfigList[key]['value'] = value
  return {
    ...state,
    chargePointConfigs: newConfigList,
    updateChargePointConfigRequestState: RequestState.SUCCEEDED,
  }
}

export const updateChargePointConfigFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    updateChargePointConfigRequestState: requestState,
  }
}

export const deleteChargePointLoading = (state) => {
  return {
    ...state,
    deleteChargePointRequestState: RequestState.LOADING,
  }
}

export const deleteChargePointSuccess = (state, { chargePointId }) => {
  if (
    state.chargePoints.some((chargePoint) => chargePoint._id === chargePointId)
  ) {
    let newChargePoints = state.chargePoints.filter(
      (chargePoint) => chargePoint._id !== chargePointId,
    )

    if (newChargePoints.length === 0) {
      let currentPath = history.location.pathname
      const index = currentPath.indexOf('station')
      currentPath = currentPath.substring(0, index - 1)
      history.push({ pathname: currentPath })
    }

    return {
      ...state,
      chargePoints: newChargePoints,
      selectedIndex: 0,
      deleteChargePointRequestState: RequestState.SUCCEEDED,
    }
  } else if (state.deleteChargePointRequestState === RequestState.LOADING)
    return { ...state, deleteChargePointRequestState: RequestState.SUCCEEDED }
  else return { ...state }
}

export const deleteMovedChargePoint = (state, { chargePointId }) => {
  if (
    state.chargePoints.some((chargePoint) => chargePoint._id === chargePointId)
  ) {
    let newChargePoints = state.chargePoints.filter(
      (chargePoint) => chargePoint._id !== chargePointId,
    )

    return {
      ...state,
      chargePoints: newChargePoints,
      selectedIndex: 0,
      deleteMovedChargePointRequestState: RequestState.SUCCEEDED,
    }
  } else return { ...state }
}

export const deleteChargePointFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteChargePointRequestState: requestState,
  }
}

export const addChargePointLoading = (state) => {
  return {
    ...state,
    addChargePointRequestState: RequestState.LOADING,
  }
}

export const addChargePointSuccess = (state, { newChargePoint }) => {
  if (
    state.chargePoints.some(
      (chargePoint) => chargePoint._id === newChargePoint._id,
    )
  ) {
    if (state.addChargePointRequestState === RequestState.LOADING) {
      const index = state.chargePoints.findIndex(
        (chargePoint) => chargePoint._id === newChargePoint._id,
      )
      return {
        ...state,
        addChargePointRequestState: RequestState.SUCCEEDED,
        chargePointLogPaginationOffset: 0,
        selectedIndex: index,
      }
    } else return { ...state }
  } else {
    let newChargePoints = [...state.chargePoints, newChargePoint]
    newChargePoints = newChargePoints.sort((a, b) => {
      let nameA = a.name.toLowerCase()
      let nameB = b.name.toLowerCase()
      if (nameA < nameB) return -1
      if (nameA > nameB) return 1
      return 0
    })
    const index = newChargePoints.findIndex(
      (chargePoint) => chargePoint._id === newChargePoint._id,
    )
    return {
      ...state,
      chargePoints: newChargePoints,
      addChargePointRequestState: RequestState.SUCCEEDED,
      chargePointLogPaginationOffset: 0,
      ...(state.chargePoints.length === 0
        ? { selectedIndex: 0 }
        : { selectedIndex: index }),
    }
  }
}

export const addChargePointFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    addChargePointRequestState: requestState,
  }
}
export const resetChargePointLoading = (state) => {
  return {
    ...state,
    resetChargePointRequestState: RequestState.LOADING,
  }
}
export const resetChargePointSuccess = (state) => {
  return {
    ...state,
    resetChargePointRequestState: RequestState.SUCCEEDED,
  }
}

export const resetChargePointFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    resetChargePointRequestState: requestState,
  }
}

export const emitterUpdateChargePoint = (state, { args: { data } }) => {
  const { huid, chargePoint } = data
  let newChargePoints = [...state.chargePoints]
  let index = newChargePoints.findIndex(
    (chargePoint) => chargePoint.huid === huid,
  )

  let newChargePointTemp = {
    ...newChargePoints[index],
  }
  if (index !== -1) {
    if (chargePoint.name) {
      newChargePointTemp['name'] = chargePoint.name
      newChargePoints[index]['name'] = chargePoint.name
    }
    if (chargePoint.connectors) {
      newChargePointTemp['connectors'] = chargePoint.connectors
      if (Array.isArray(newChargePoints[index].evses)) {
        const updatedConnectors = chargePoint.connectors
        if (chargePoint.evse) {
          const foundEvse = newChargePoints[index].evses?.find(
            (evse) =>
              evse._id?.toString() === chargePoint.evse?._id?.toString(),
          )
          if (!foundEvse) {
            newChargePoints[index].evses.push(chargePoint.evse)
          }
        } else {
          for (const evse of newChargePoints[index].evses) {
            if (Array.isArray(evse.connectors)) {
              evse.connectors = evse.connectors.map((connector) => {
                const updatedConnector = updatedConnectors.find(
                  (c) => c.uid === connector.uid,
                )
                if (updatedConnector) {
                  return {
                    ...updatedConnector,
                    tariffIds: connector.tariffIds,
                    session: connector.session,
                  }
                }
                return connector
              })
            }
          }
        }
      }
    }

    if (chargePoint.isRemoved !== undefined) {
      if (Array.isArray(newChargePoints[index].evses)) {
        for (const evse of newChargePoints[index].evses) {
          evse.isRemoved = chargePoint.isRemoved
        }
      }
    }

    if (chargePoint.isOnline === true || chargePoint.isOnline === false) {
      newChargePointTemp['isOnline'] = chargePoint.isOnline
      newChargePoints[index]['isOnline'] = chargePoint.isOnline
    }
    if (chargePoint.isPrivate === true || chargePoint.isPrivate === false) {
      newChargePointTemp['isPrivate'] = chargePoint.isPrivate
      newChargePoints[index]['isPrivate'] = chargePoint.isPrivate
    }
  } else return { ...state }
  if (
    chargePoint.isActivated === true &&
    !newChargePoints[index]['isActivated']
  ) {
    newChargePointTemp['isActivated'] = true
    newChargePoints[index] = newChargePointTemp
  }

  return {
    ...state,
    chargePoints: newChargePoints,
  }
}

export const emitterAddChargePoint = (state, { args: { data } }) => {
  if (state.chargePoints.some((chargePoint) => chargePoint._id === data._id)) {
    return { ...state }
  } else {
    if (state.chargePoints.length === 0) {
      let currentPath = history.location.pathname
      const index = currentPath.indexOf('station')
      if (index === -1) {
        currentPath = currentPath + `/stations/${data._id}`
        history.push({ pathname: currentPath })
      }
    }
    let selectedChargePoint = state.chargePoints[state.selectedIndex]
    let newChargePoints = [...state.chargePoints, data]
    newChargePoints = newChargePoints.sort((a, b) => {
      let nameA = a.name.toLowerCase()
      let nameB = b.name.toLowerCase()
      if (nameA < nameB) return -1
      if (nameA > nameB) return 1
      return 0
    })
    const index = newChargePoints.findIndex(
      (chargePoint) => chargePoint._id === selectedChargePoint?._id,
    )
    return {
      ...state,
      chargePoints: newChargePoints,
      ...(state.chargePoints.length === 0
        ? { selectedIndex: 0 }
        : { selectedIndex: index }),
    }
  }
}

export const emitterDeleteChargePoint = (state, { args: { data } }) => {
  if (state.chargePoints.some((chargePoint) => chargePoint.huid === data)) {
    const index = state.chargePoints.findIndex(
      (chargePoint) => chargePoint.huid === data,
    )
    let currentlySelectedFlag = false
    if (index !== -1 && index === state.selectedIndex)
      currentlySelectedFlag = true
    let newChargePoints = state.chargePoints.filter(
      (chargePoint) => chargePoint.huid !== data,
    )

    return {
      ...state,
      chargePoints: newChargePoints,
      ...(currentlySelectedFlag || newChargePoints.length === 1
        ? { selectedIndex: 0 }
        : {}),
      deleteMovedChargePointRequestState: RequestState.SUCCEEDED,
    }
  } else return { ...state }
}

export const resetFilters = (state) => {
  let chargePoint = state.chargePoints[state.selectedIndex]
  let connectorUids = chargePoint?.evses
    ?.flatMap((evse) => evse.connectors || [])
    .filter((connector) => connector.uid !== 0)
    .map((connector) => connector.uid)
  const updatedFilter = INITIAL_STATE.chargePointTransactionFilter.map(
    (filter) => {
      if (filter.field === 'connector') {
        return {
          ...filter,
          data: connectorUids,
        }
      }
      return filter
    },
  )
  return {
    ...state,
    chargePointLogFilter: [
      ...JSON.parse(JSON.stringify(INITIAL_STATE.chargePointLogFilter)),
    ],
    chargePointTransactionFilter: [
      ...JSON.parse(JSON.stringify(updatedFilter)),
    ],
    chargePointStatisticsFilter: getDefaultChargePointStatisticsFilter(),
  }
}
export const emitterUpdateConnectorSessionStatus = (
  state,
  { args: { data } },
) => {
  let newChargePoint = state.chargePoints[state.selectedIndex]
  let newChargePoints = [...state.chargePoints]

  let found = false
  for (const evse of newChargePoint.evses || []) {
    if (Array.isArray(evse.connectors)) {
      const connectorIndex = evse.connectors.findIndex(
        (connector) => connector.uid === data.connectorUid,
      )
      if (connectorIndex !== -1) {
        if (data.status === InfinityEnums.ChargingSessionStatus.ENDED) {
          evse.connectors[connectorIndex].session = undefined
        } else {
          evse.connectors[connectorIndex].session = data
          const current = state.chargingSessionDetails
          const isEmpty =
            !current ||
            (Object.keys(current).length === 0 &&
              current.constructor === Object)

          if (isEmpty) {
            state.chargingSessionDetails = data
          } else if (current._id === data._id) {
            state.chargingSessionDetails = {
              ...current,
              ...data,
            }
          }
        }

        found = true
        break
      }
    }
  }
  if (!found) return { ...state }
  newChargePoints[state.selectedIndex] = newChargePoint

  return {
    ...state,
    chargePoints: [...newChargePoints],
  }
}

export const clearChargePointCacheLoading = (state) => {
  return {
    ...state,
    clearChargePointCacheRequestState: RequestState.LOADING,
  }
}
export const clearChargePointCacheSuccess = (state) => {
  return {
    ...state,
    clearChargePointCacheRequestState: RequestState.SUCCEEDED,
  }
}

export const clearChargePointCacheFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    clearChargePointCacheRequestState: requestState,
  }
}

export const changeChargePointAvailabilityLoading = (state) => {
  return {
    ...state,
    changeChargePointAvailabilityRequestState: RequestState.LOADING,
  }
}

export const changeChargePointAvailabilitySuccess = (state) => {
  return {
    ...state,
    changeChargePointAvailabilityRequestState: RequestState.SUCCEEDED,
  }
}

export const changeChargePointAvailabilityFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    changeChargePointAvailabilityRequestState: requestState,
  }
}

export const updateChargePointFirmwareLoading = (state) => {
  return {
    ...state,
    updateChargePointFirmwareRequestState: RequestState.LOADING,
  }
}

export const updateChargePointFirmwareSuccess = (state) => {
  return {
    ...state,
    updateChargePointFirmwareRequestState: RequestState.SUCCEEDED,
  }
}

export const updateChargePointFirmwareFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    updateChargePointFirmwareRequestState: requestState,
  }
}

export const fetchChargePointUploadDiagnosticsLoading = (state) => {
  return {
    ...state,
    fetchChargePointUploadDiagnosticsRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointUploadDiagnosticsSuccess = (
  state,
  { uploadDiagnostics },
) => {
  return {
    ...state,
    chargePointUploadDiagnostics: [...uploadDiagnostics],
    fetchChargePointUploadDiagnosticsRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointTariffsLoading = (state) => {
  return {
    ...state,
    fetchChargePointTariffsRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointTariffsSuccess = (state, { tariffs }) => {
  return {
    ...state,
    chargePointTariffs: tariffs,
    fetchChargePointTariffsRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointTariffsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointTariffsRequestState: requestState,
  }
}

export const deleteChargePointTariffsLoading = (state) => {
  return {
    ...state,
    deleteChargePointTariffsRequestState: RequestState.LOADING,
  }
}

export const deleteChargePointTariffsSuccess = (state, { tariffs }) => {
  const chargePointTariffs = state.chargePointTariffs
  const filteredTariffs = chargePointTariffs.filter((tarrSchema) => {
    return tariffs.indexOf(tarrSchema._id) === -1
  })
  return {
    ...state,
    chargePointTariffs: filteredTariffs,
    deleteChargePointTariffsRequestState: RequestState.SUCCEEDED,
  }
}

export const deleteChargePointTariffsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteChargePointTariffsRequestState: requestState,
  }
}

export const fetchChargePointAccessGroupsLoading = (state) => {
  return {
    ...state,
    fetchChargePointAccessGroupsRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointAccessGroupsSuccess = (
  state,
  { accessGroups },
) => {
  return {
    ...state,
    chargePointAccessGroups: [...accessGroups],
    fetchChargePointAccessGroupsRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointAccessGroupsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointAccessGroupsRequestState: requestState,
  }
}

export const addChargePointTariffsLoading = (state) => {
  return {
    ...state,
    addChargePointTariffsRequestState: RequestState.LOADING,
  }
}

export const addChargePointTariffsSuccess = (state, { tariffs }) => {
  return {
    ...state,
    chargePointTariffs: [...new Set(state.chargePointTariffs.concat(tariffs))],
    addChargePointTariffsRequestState: RequestState.SUCCEEDED,
  }
}

export const addChargePointTariffsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    addChargePointTariffsRequestState: requestState,
  }
}

export const fetchChargePointUploadDiagnosticsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointUploadDiagnosticsRequestState: requestState,
  }
}

export const requestChargePointUploadDiagnosticsLoading = (state) => {
  return {
    ...state,
    requestChargePointUploadDiagnosticsRequestState: RequestState.LOADING,
  }
}

export const requestChargePointUploadDiagnosticsSuccess = (
  state,
  { newUploadDiagnostics },
) => {
  const oldUploadDiagnostics = state.chargePointUploadDiagnostics
  return {
    ...state,
    chargePointUploadDiagnostics: [
      newUploadDiagnostics,
      ...oldUploadDiagnostics,
    ],
    requestChargePointUploadDiagnosticsRequestState: RequestState.SUCCEEDED,
  }
}

export const requestChargePointUploadDiagnosticsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    requestChargePointUploadDiagnosticsRequestState: requestState,
  }
}

export const updateChargePointFirmwareUpload = (state, { progress }) => {
  return {
    ...state,
    chargePointFirmwareUploadProgress: progress,
  }
}

export const diagnosticsStatusNotificationLoading = (state) => {
  return {
    ...state,
    diagnosticsStatusNotificationRequestState: RequestState.LOADING,
  }
}

export const diagnosticsStatusNotificationSuccess = (state) => {
  return {
    ...state,
    diagnosticsStatusNotificationRequestState: RequestState.SUCCEEDED,
  }
}

export const emitterUpdateChargePointDiagnostics = (
  state,
  { args: { data } },
) => {
  const { status } = data
  let chargePointDiagnostics = state.chargePointUploadDiagnostics
  chargePointDiagnostics[0].status = status
  return {
    ...state,
    chargePointUploadDiagnostics: [...chargePointDiagnostics],
  }
}

export const diagnosticsStatusNotificationFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    diagnosticsStatusNotificationRequestState: requestState,
  }
}

export const fetchChargePointPrivacyScheduleLoading = (state) => {
  return {
    ...state,
    fetchChargePointPrivacyScheduleRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointPrivacyScheduleSuccess = (
  state,
  { privacySchedule },
) => {
  return {
    ...state,
    chargePointPrivacySchedule: privacySchedule,
    fetchChargePointPrivacyScheduleRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointPrivacyScheduleFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointPrivacyScheduleRequestState: requestState,
  }
}

export const deleteChargePointPrivacyRulesLoading = (state) => {
  return {
    ...state,
    deleteChargePointPrivacyRulesRequestState: RequestState.LOADING,
  }
}

export const deleteChargePointPrivacyRulesSuccess = (
  state,
  { privacyRules },
) => {
  const chargePointPrivacySchedule = state.chargePointPrivacySchedule
  const filteredPrivacyRules = chargePointPrivacySchedule.filter(
    (ruleObject) => {
      return privacyRules.indexOf(ruleObject.rule._id) === -1
    },
  )
  return {
    ...state,
    chargePointPrivacySchedule: filteredPrivacyRules,
    deleteChargePointPrivacyRulesRequestState: RequestState.SUCCEEDED,
  }
}

export const deleteChargePointPrivacyRulesFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteChargePointPrivacyRulesRequestState: requestState,
  }
}
export const addChargePointPrivacyRulesLoading = (state) => {
  return {
    ...state,
    addChargePointPrivacyRulesRequestState: RequestState.LOADING,
  }
}

export const addChargePointPrivacyRulesSuccess = (state, { privacyRules }) => {
  return {
    ...state,
    chargePointPrivacySchedule: [
      ...new Set(state.chargePointPrivacySchedule.concat(privacyRules)),
    ],
    addChargePointPrivacyRulesRequestState: RequestState.SUCCEEDED,
  }
}

export const addChargePointPrivacyRulesFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    addChargePointPrivacyRulesRequestState: requestState,
  }
}
export const addChargePointAccessGroupsBulkLoading = (state) => {
  return {
    ...state,
    addChargePointAccessGroupsBulkRequestState: RequestState.LOADING,
  }
}
export const clearChargePointAccessGroups = (state) => {
  return {
    ...state,
    chargePointAccessGroups: [],
  }
}

export const deleteChargePointAccessGroupsBulkLoading = (state) => {
  return {
    ...state,
    deleteChargePointAccessGroupsBulkRequestState: RequestState.LOADING,
  }
}

export const deleteChargePointAccessGroupsBulkSuccess = (state, { ids }) => {
  let newAccessGroups = state.chargePointAccessGroups
  for (const id of ids) {
    newAccessGroups = newAccessGroups.filter((group) => group._id !== id)
  }

  return {
    ...state,
    chargePointAccessGroups: [...newAccessGroups],
    deleteChargePointAccessGroupsBulkRequestState: RequestState.SUCCEEDED,
  }
}

export const deleteChargePointAccessGroupsBulkFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteChargePointAccessGroupsBulkRequestState: requestState,
  }
}

export const addChargePointAccessGroupsBulkSuccess = (
  state,
  { accessGroups },
) => {
  return {
    ...state,
    chargePointAccessGroups: [
      ...state.chargePointAccessGroups,
      ...accessGroups,
    ],
    addChargePointAccessGroupsBulkRequestState: RequestState.SUCCEEDED,
  }
}

export const addChargePointAccessGroupsBulkFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    addChargePointAccessGroupsBulkRequestState: requestState,
  }
}

export const resetChargePointSpecifications = (state) => {
  return {
    ...state,
    chargePointTariffs: [],
    chargePointPrivacySchedule: [],
    chargePointAccessGroups: [],
  }
}
export const setIsChargePointLogsLive = (state, { flag }) => {
  return {
    ...state,
    isChargePointLogsLive: flag,
  }
}

export const fetchChargePointUptimeStatisticsLoading = (state) => {
  return {
    ...state,
    fetchChargePointUptimeStatisticsRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointUptimeStatisticsSuccess = (
  state,
  { cpUptimeStatistics },
) => {
  return {
    ...state,
    chargePointUptimeData: cpUptimeStatistics,
    fetchChargePointUptimeStatisticsRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointUptimeStatisticsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointUptimeStatisticsRequestState: requestState,
  }
}

export const setChargePointStatisticsFilter = (state, { newFilter }) => {
  return {
    ...state,
    chargePointStatisticsFilter: newFilter,
  }
}

export const fetchConnectorsUtilizationLoading = (state) => {
  return {
    ...state,
    fetchConnectorsUtilizationRequestState: RequestState.LOADING,
  }
}

export const fetchConnectorsUtilizationSuccess = (
  state,
  { connectorsUtilization },
) => {
  return {
    ...state,
    connectorsUtilizationData: connectorsUtilization,
    fetchConnectorsUtilizationRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchConnectorsUtilizationFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchConnectorsUtilizationRequestState: requestState,
  }
}

export const fetchChargePointSubscribedAlertsLoading = (state) => {
  return {
    ...state,
    fetchChargePointSubscribedAlertsRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointSubscribedAlertsSuccess = (state, { alerts }) => {
  return {
    ...state,
    subscribedAlerts: [...alerts],
    fetchChargePointSubscribedAlertsRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointSubscribedAlertsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointSubscribedAlertsRequestState: requestState,
  }
}

export const fetchChargePointAlertsLoading = (state) => {
  return {
    ...state,
    fetchChargePointAlertsRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointAlertsSuccess = (state, { alerts }) => {
  return {
    ...state,
    alerts: [...alerts],
    fetchChargePointAlertsRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointAlertsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointAlertsRequestState: requestState,
  }
}

export const updateChargePointAlertsLoading = (state) => {
  return {
    ...state,
    updateChargePointAlertsRequestState: RequestState.LOADING,
  }
}

export const updateChargePointAlertsSuccess = (
  state,
  { data, alertChanges },
) => {
  let subscribedAlerts = state.subscribedAlerts
  let alerts = state.alerts
  let chargePoint = state.chargePoints[state.selectedIndex]

  for (const [key, value] of Object.entries(alertChanges)) {
    const subscribedAlertIndex = subscribedAlerts.findIndex(
      (alert) => alert._id === key,
    )
    if (subscribedAlertIndex !== -1) {
      if ('isGlobal' in value) {
        if (value.isGlobal) {
          const newExcludeArray = subscribedAlerts[
            subscribedAlertIndex
          ].exclude.filter((huid) => huid !== chargePoint.huid)
          subscribedAlerts[subscribedAlertIndex].exclude = newExcludeArray
        } else {
          subscribedAlerts[subscribedAlertIndex].exclude.push(chargePoint.huid)
        }
      } else {
        if (!value.chargePoints) {
          const alertIndex = alerts.findIndex((alert) => alert._id === key)
          if (alertIndex === -1)
            alerts.push(subscribedAlerts[subscribedAlertIndex])
          subscribedAlerts.splice(subscribedAlertIndex, 1)
        }
      }
    }
  }
  if (data) subscribedAlerts = [...subscribedAlerts, ...data]
  return {
    ...state,
    subscribedAlerts: [...subscribedAlerts],
    alerts: [...alerts],
    updateChargePointAlertsRequestState: RequestState.SUCCEEDED,
  }
}

export const updateChargePointAlertsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    updateChargePointAlertsRequestState: requestState,
  }
}

export const fetchChargePointLocalListLoading = (state) => {
  return {
    ...state,
    fetchChargePointLocalListRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointLocalListSuccess = (state, { localList }) => {
  return {
    ...state,
    chargePointLocalList: { ...localList },
    fetchChargePointLocalListRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointLocalListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointLocalListRequestState: requestState,
  }
}
export const updateChargePointLocalListLoading = (state) => {
  return {
    ...state,
    updateChargePointLocalListRequestState: RequestState.LOADING,
  }
}

export const updateChargePointLocalListSuccess = (state, { localList }) => {
  return {
    ...state,
    updateChargePointLocalListRequestState: RequestState.SUCCEEDED,
  }
}

export const updateChargePointLocalListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    updateChargePointLocalListRequestState: requestState,
  }
}

export const fetchChargePointChargingProfilesLoading = (state) => {
  return {
    ...state,
    fetchChargePointChargingProfilesRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointChargingProfilesSuccess = (
  state,
  { chargingProfiles },
) => {
  return {
    ...state,
    chargingProfiles: [...chargingProfiles],
    fetchChargePointChargingProfilesRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointChargingProfilesFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointChargingProfilesRequestState: requestState,
  }
}

export const fetchChargePointCompositeScheduleLoading = (state) => {
  return {
    ...state,
    fetchChargePointCompositeScheduleRequestState: RequestState.LOADING,
  }
}

export const fetchChargePointCompositeScheduleSuccess = (
  state,
  { compositeSchedule },
) => {
  return {
    ...state,
    compositeSchedule: { ...compositeSchedule },
    fetchChargePointCompositeScheduleRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchChargePointCompositeScheduleFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargePointCompositeScheduleRequestState: requestState,
  }
}

export const clearChargePointChargingProfileLoading = (state) => {
  return {
    ...state,
    clearChargePointChargingProfileRequestState: RequestState.LOADING,
  }
}

export const clearChargePointChargingProfileSuccess = (
  state,
  { chargingProfileIds },
) => {
  let newChargingProfiles = state.chargingProfiles
  newChargingProfiles = newChargingProfiles.filter(
    (chargingProfile) =>
      !chargingProfileIds.includes(chargingProfile.profile.uid),
  )
  return {
    ...state,
    chargingProfiles: [...newChargingProfiles],
    clearChargePointChargingProfileRequestState: RequestState.SUCCEEDED,
  }
}

export const clearChargePointChargingProfileFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    clearChargePointChargingProfileRequestState: requestState,
  }
}

export const setChargePointChargingProfileLoading = (state) => {
  return {
    ...state,
    setChargePointChargingProfileRequestState: RequestState.LOADING,
  }
}

export const setChargePointChargingProfileSuccess = (
  state,
  { newChargingProfile },
) => {
  let chargingProfiles = state.chargingProfiles
  const index = chargingProfiles.findIndex(
    (chargingProfile) =>
      chargingProfile.profile.uid === newChargingProfile.profile.uid,
  )
  if (index === -1) chargingProfiles.push(newChargingProfile)
  return {
    ...state,
    chargingProfiles: [...chargingProfiles],
    setChargePointChargingProfileRequestState: RequestState.SUCCEEDED,
  }
}

export const setChargePointChargingProfileFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    setChargePointChargingProfileRequestState: requestState,
  }
}

export const createChargePointChargingProfileLoading = (state) => {
  return {
    ...state,
    createChargePointChargingProfileRequestState: RequestState.LOADING,
  }
}

export const createChargePointChargingProfileSuccess = (state) => {
  return {
    ...state,
    createChargePointChargingProfileRequestState: RequestState.SUCCEEDED,
  }
}

export const createChargePointChargingProfileFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    createChargePointChargingProfileRequestState: requestState,
  }
}

export const fetchConnectorTypesLoading = (state) => {
  return {
    ...state,
    fetchConnectorTypesRequestState: RequestState.LOADING,
  }
}

export const fetchConnectorTypesSuccess = (state, { filters }) => {
  return {
    ...state,
    connectorTypes: filters,
    fetchConnectorTypesRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchConnectorTypesFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchConnectorTypesRequestState: requestState,
  }
}

export const fetchChargingSessionLogsLoading = (state) => {
  return {
    ...state,
    fetchChargingSessionLogsRequestState: RequestState.LOADING,
  }
}
export const fetchChargingSessionLogsLoadingMore = (state) => {
  return {
    ...state,
    fetchChargingSessionLogsMoreRequestState: RequestState.LOADING_MORE,
  }
}
export const fetchChargingSessionLogsSuccess = (
  state,
  { offset, chargingSessionLogs, nextOffset },
) => {
  let result = []
  for (let j = 0; j < chargingSessionLogs.length; j++) {
    if (
      !state.chargingSessionLogs.some(
        (chargingSessionLog) =>
          chargingSessionLog._id === chargingSessionLogs[j]._id,
      )
    ) {
      result.push(chargingSessionLogs[j])
    }
  }

  if (offset === 0) {
    return {
      ...state,
      fetchChargingSessionLogsRequestState: RequestState.SUCCEEDED,
      chargingSessionLogs: [...chargingSessionLogs],
      chargingSessionLogsPaginationOffset: nextOffset,
    }
  } else {
    return {
      ...state,
      chargingSessionLogs: [...state.chargingSessionLogs, ...result],
      fetchChargingSessionLogsRequestState: RequestState.SUCCEEDED,
      chargingSessionLogsPaginationOffset: nextOffset,
    }
  }
}
export const fetchChargingSessionLogsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargingSessionLogsRequestState: requestState,
  }
}
export const resetChargingSessionLogs = (state) => {
  return {
    ...state,
    chargingSessionLogsPaginationOffset: 0,
    chargingSessionLogs: [],
    chargingSessionLogsFirstItemIndex: 1000000,
    fetchChargingSessionLogsRequestState: RequestState.UNINITIALIZED,
  }
}
export const setChargingSessionLogsFilter = (state, { newFilter }) => {
  return {
    ...state,
    chargingSessionLogsFilter: newFilter,
  }
}
export const resetChargingSessionLogsFilters = (state) => {
  return {
    ...state,
    chargingSessionLogsFilter: chargingSessionLogsFilter,
  }
}
export const setChargingSessionLogsPaginationOffset = (state, { offset }) => {
  return {
    ...state,
    chargingSessionLogsPaginationOffset: offset,
  }
}
export const prependChargingSessionLogList = (
  state,
  { chargingSessionLogs },
) => {
  let appendCount = 0
  let tempLogs = []
  for (let chargingSessionLog of chargingSessionLogs) {
    tempLogs.push(chargingSessionLog)
    if (chargingSessionLog.requestMessage) appendCount++
    if (chargingSessionLog.responseMessage) appendCount++
  }
  if (tempLogs.length > 1) tempLogs = tempLogs.reverse()
  return {
    ...state,
    chargingSessionLogs: [...tempLogs, ...state.chargingSessionLogs],
    chargingSessionLogsFirstItemIndex:
      state.chargingSessionLogsFirstItemIndex - appendCount,
    bufferedChargingSessionLogs: [],
  }
}

export const appendBufferChargingSessionLogList = (
  state,
  { chargingSessionLogs },
) => {
  return {
    ...state,
    bufferedChargingSessionLogs: [
      ...chargingSessionLogs,
      ...state.bufferedChargingSessionLogs,
    ],
  }
}
export const setChargingSessionLogPaginationOffset = (state, { offset }) => {
  return {
    ...state,
    chargingSessionLogsPaginationOffset: offset,
  }
}

export const fetchChargingSessionDetailsLoading = (state) => {
  return {
    ...state,
    fetchChargingSessionDetailsRequestState: RequestState.LOADING,
  }
}
export const fetchChargingSessionDetailsSuccess = (
  state,
  { chargingSession },
) => {
  return {
    ...state,
    chargingSessionDetails: chargingSession,
    fetchChargingSessionDetailsRequestState: RequestState.SUCCEEDED,
  }
}
export const fetchChargingSessionDetailsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargingSessionDetailsRequestState: requestState,
  }
}

export const fetchChargingSessionEventsLoading = (state) => {
  return {
    ...state,
    fetchChargingSessionEventsRequestState: RequestState.LOADING,
  }
}
export const fetchChargingSessionEventsSuccess = (
  state,
  { chargingSessionEvents },
) => {
  return {
    ...state,
    chargingSessionEvents: [...chargingSessionEvents],
    fetchChargingSessionEventsRequestState: RequestState.SUCCEEDED,
  }
}
export const fetchChargingSessionEventsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargingSessionEventsRequestState: requestState,
  }
}
export const resetChargingSessionEvents = (state) => {
  return {
    ...state,
    chargingSessionEvents: [],
    fetchChargingSessionEventsRequestState: RequestState.UNINITIALIZED,
  }
}
export const resetChargingSessionDetails = (state) => {
  return {
    ...state,
    chargingSessionDetails: [],
    fetchChargingSessionDetailsRequestState: RequestState.UNINITIALIZED,
  }
}

export const emitterUpdateChargingEvents = (state, { data }) => {
  const chargingEvents = state.chargingSessionEvents || []

  const sessionIDIndex = chargingEvents.findIndex(
    (event) => event.sessionId === data.sessionId,
  )
  const eventIndex = chargingEvents.findIndex((event) => event._id === data._id)

  let updatedEvents
  if (eventIndex !== -1 && sessionIDIndex !== -1) {
    const existingEvent = chargingEvents[eventIndex]
    const dataEnergyTransfer = data.energyTransfer

    let updatedEnergyTransfer = [...(existingEvent.energyTransfer || [])]

    if (dataEnergyTransfer) {
      const energyTransfer = Array.isArray(dataEnergyTransfer)
        ? dataEnergyTransfer[0]
        : dataEnergyTransfer

      if (energyTransfer && energyTransfer._id) {
        const energyIndex = updatedEnergyTransfer.findIndex(
          (event) => event._id === energyTransfer._id,
        )

        if (energyIndex !== -1) {
          updatedEnergyTransfer[energyIndex] = energyTransfer
        } else {
          updatedEnergyTransfer.push(energyTransfer)
        }
      }
    }

    const updatedEvent = {
      ...existingEvent,
      ...data,
      energyTransfer: updatedEnergyTransfer,
    }

    updatedEvents = [...chargingEvents]
    updatedEvents[eventIndex] = updatedEvent
  } else if (sessionIDIndex !== -1) {
    const newEvent = {
      ...data,
      sessionId: data.sessionId,
      energyTransfer: Array.isArray(data.energyTransfer)
        ? data.energyTransfer
        : data.energyTransfer
        ? [data.energyTransfer]
        : [],
    }

    updatedEvents = [...chargingEvents, newEvent]
  } else {
    updatedEvents = [...chargingEvents]
  }

  return {
    ...state,
    chargingSessionEvents: updatedEvents,
  }
}

export const emitterUpdateChargingSessionDetails = (state, { data }) => {
  let chargingSessionDetails = state.chargingSessionDetails
  if (
    data.status &&
    data.status === InfinityEnums.ChargingSessionStatus.ENDED &&
    chargingSessionDetails &&
    chargingSessionDetails._id === data.chargingSessionID
  ) {
    chargingSessionDetails = {
      ...chargingSessionDetails,
      status: data.status,
      startedAt: data.chargingSessionStart,
      updatedAt: data.chargingSessionEnd,
    }
  }
  if (chargingSessionDetails && chargingSessionDetails._id === data._id) {
    chargingSessionDetails = {
      ...chargingSessionDetails,
      ...data,
    }
  }
  return {
    ...state,
    chargingSessionDetails,
  }
}
export const setIsChargingAnalyticsLive = (state, { flag }) => {
  return {
    ...state,
    isChargingAnalyticsLive: flag,
  }
}
export const reverseTransactionLoading = (state) => {
  return {
    ...state,
    reverseTransactionRequestState: RequestState.LOADING,
  }
}

export const reverseTransactionSuccess = (state) => {
  return {
    ...state,
    reverseTransactionRequestState: RequestState.SUCCEEDED,
  }
}

export const reverseTransactionFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    reverseTransactionRequestState: requestState,
  }
}
export const blockChargePointLoading = (state) => {
  return {
    ...state,
    blockChargePointRequestState: RequestState.LOADING,
  }
}

export const blockChargePointSuccess = (state) => {
  return {
    ...state,
    blockChargePointRequestState: RequestState.SUCCEEDED,
  }
}

export const blockChargePointFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    blockChargePointRequestState: requestState,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [ChargePointTypes.FETCH_CHARGE_POINT_LIST_LOADING]:
    fetchChargePointListLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_LIST_SUCCESS]:
    fetchChargePointListSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_LIST_FAIL]: fetchChargePointListFail,
  [ChargePointTypes.CLEAR_CHARGE_POINTS]: clearChargePoints,
  [ChargePointTypes.SET_CHARGE_POINT_SELECTED_INDEX]:
    setChargePointSelectedIndex,
  [ChargePointTypes.RESET_CHARGE_POINT_STATE]: resetChargePointState,
  [ChargePointTypes.UPDATE_CHARGE_POINT_LOADING]: updateChargePointLoading,
  [ChargePointTypes.UPDATE_CHARGE_POINT_SUCCESS]: updateChargePointSuccess,
  [ChargePointTypes.UPDATE_CHARGE_POINT_FAIL]: updateChargePointFail,
  [ChargePointTypes.FETCH_CHARGE_POINT_LOG_LIST_LOADING]:
    fetchChargePointLogListLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_LOG_LIST_SUCCESS]:
    fetchChargePointLogListSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_LOG_LIST_FAIL]:
    fetchChargePointLogListFail,
  [ChargePointTypes.CLEAR_CHARGE_POINT_LOGS]: clearChargePointLogs,
  [ChargePointTypes.SET_CHARGE_POINT_LOGS_FILTER]: setChargePointLogsFilter,
  [ChargePointTypes.FETCH_CHARGE_POINT_TRANSACTION_LIST_LOADING]:
    fetchChargePointTransactionListLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_TRANSACTION_LIST_SUCCESS]:
    fetchChargePointTransactionListSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_TRANSACTION_LIST_FAIL]:
    fetchChargePointTransactionListFail,
  [ChargePointTypes.CLEAR_CHARGE_POINT_TRANSACTIONS]:
    clearChargePointTransactions,
  [ChargePointTypes.SET_CHARGE_POINT_TRANSACTIONS_FILTER]:
    setChargePointTransactionsFilter,
  [ChargePointTypes.FETCH_CHARGE_POINT_CONFIG_LIST_LOADING]:
    fetchChargePointConfigListLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_CONFIG_LIST_SUCCESS]:
    fetchChargePointConfigListSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_CONFIG_LIST_FAIL]:
    fetchChargePointConfigListFail,
  [ChargePointTypes.CLEAR_CHARGE_POINT_CONFIGS]: clearChargePointConfigs,
  [ChargePointTypes.SET_CHARGE_POINT_FILTER_TEXT]: setChargePointFilterText,
  [ChargePointTypes.UPDATE_CHARGE_POINT_CONFIG_LOADING]:
    updateChargePointConfigLoading,
  [ChargePointTypes.UPDATE_CHARGE_POINT_CONFIG_SUCCESS]:
    updateChargePointConfigSuccess,
  [ChargePointTypes.UPDATE_CHARGE_POINT_CONFIG_FAIL]:
    updateChargePointConfigFail,
  [ChargePointTypes.DELETE_CHARGE_POINT_LOADING]: deleteChargePointLoading,
  [ChargePointTypes.DELETE_CHARGE_POINT_SUCCESS]: deleteChargePointSuccess,
  [ChargePointTypes.DELETE_CHARGE_POINT_FAIL]: deleteChargePointFail,
  [ChargePointTypes.ADD_CHARGE_POINT_LOADING]: addChargePointLoading,
  [ChargePointTypes.ADD_CHARGE_POINT_SUCCESS]: addChargePointSuccess,
  [ChargePointTypes.ADD_CHARGE_POINT_FAIL]: addChargePointFail,
  [ChargePointTypes.DELETE_MOVED_CHARGE_POINT]: deleteMovedChargePoint,
  [ChargePointTypes.MOVE_CHARGE_POINT_LOADING]: moveChargePointLoading,
  [ChargePointTypes.MOVE_CHARGE_POINT_SUCCESS]: moveChargePointSuccess,
  [ChargePointTypes.MOVE_CHARGE_POINT_FAIL]: moveChargePointFail,
  [ChargePointTypes.SET_CHARGE_POINT_LOG_PAGINATION_OFFSET]:
    setChargePointLogPaginationOffset,
  [ChargePointTypes.SET_CHARGE_POINT_TRANSACTION_PAGINATION_OFFSET]:
    setChargePointTransactionPaginationOffset,
  [ChargePointTypes.RESET_CHARGE_POINT_LOADING]: resetChargePointLoading,
  [ChargePointTypes.RESET_CHARGE_POINT_SUCCESS]: resetChargePointSuccess,
  [ChargePointTypes.RESET_CHARGE_POINT_FAIL]: resetChargePointFail,
  [ChargePointTypes.EMITTER_UPDATE_CHARGE_POINT]: emitterUpdateChargePoint,
  [ChargePointTypes.EMITTER_ADD_CHARGE_POINT]: emitterAddChargePoint,
  [ChargePointTypes.EMITTER_DELETE_CHARGE_POINT]: emitterDeleteChargePoint,
  [ChargePointTypes.RESET_FILTERS]: resetFilters,
  [ChargePointTypes.EMITTER_UPDATE_CONNECTOR_SESSION_STATUS]:
    emitterUpdateConnectorSessionStatus,
  [ChargePointTypes.FETCH_CHARGE_POINT_LOADING]: fetchChargePointLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_SUCCESS]: fetchChargePointSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_FAIL]: fetchChargePointFail,
  [ChargePointTypes.CLEAR_CHARGE_POINT_CACHE_LOADING]:
    clearChargePointCacheLoading,
  [ChargePointTypes.CLEAR_CHARGE_POINT_CACHE_SUCCESS]:
    clearChargePointCacheSuccess,
  [ChargePointTypes.CLEAR_CHARGE_POINT_CACHE_FAIL]: clearChargePointCacheFail,
  [ChargePointTypes.CHANGE_CHARGE_POINT_AVAILABILITY_LOADING]:
    changeChargePointAvailabilityLoading,
  [ChargePointTypes.CHANGE_CHARGE_POINT_AVAILABILITY_SUCCESS]:
    changeChargePointAvailabilitySuccess,
  [ChargePointTypes.CHANGE_CHARGE_POINT_AVAILABILITY_FAIL]:
    changeChargePointAvailabilityFail,
  [ChargePointTypes.UPDATE_CHARGE_POINT_FIRMWARE_LOADING]:
    updateChargePointFirmwareLoading,
  [ChargePointTypes.UPDATE_CHARGE_POINT_FIRMWARE_SUCCESS]:
    updateChargePointFirmwareSuccess,
  [ChargePointTypes.UPDATE_CHARGE_POINT_FIRMWARE_FAIL]:
    updateChargePointFirmwareFail,
  [ChargePointTypes.UPDATE_CHARGE_POINT_FIRMWARE_UPLOAD]:
    updateChargePointFirmwareUpload,
  [ChargePointTypes.FETCH_CHARGE_POINT_UPLOAD_DIAGNOSTICS_LOADING]:
    fetchChargePointUploadDiagnosticsLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_UPLOAD_DIAGNOSTICS_SUCCESS]:
    fetchChargePointUploadDiagnosticsSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_UPLOAD_DIAGNOSTICS_FAIL]:
    fetchChargePointUploadDiagnosticsFail,
  [ChargePointTypes.REQUEST_CHARGE_POINT_UPLOAD_DIAGNOSTICS_LOADING]:
    requestChargePointUploadDiagnosticsLoading,
  [ChargePointTypes.REQUEST_CHARGE_POINT_UPLOAD_DIAGNOSTICS_SUCCESS]:
    requestChargePointUploadDiagnosticsSuccess,
  [ChargePointTypes.REQUEST_CHARGE_POINT_UPLOAD_DIAGNOSTICS_FAIL]:
    requestChargePointUploadDiagnosticsFail,
  [ChargePointTypes.DIAGNOSTICS_STATUS_NOTIFICATION_LOADING]:
    diagnosticsStatusNotificationLoading,
  [ChargePointTypes.DIAGNOSTICS_STATUS_NOTIFICATION_SUCCESS]:
    diagnosticsStatusNotificationSuccess,
  [ChargePointTypes.DIAGNOSTICS_STATUS_NOTIFICATION_FAIL]:
    diagnosticsStatusNotificationFail,
  [ChargePointTypes.EMITTER_UPDATE_CHARGE_POINT_DIAGNOSTICS]:
    emitterUpdateChargePointDiagnostics,
  [ChargePointTypes.FETCH_CHARGE_POINT_PRIVACY_SCHEDULE_LOADING]:
    fetchChargePointPrivacyScheduleLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_PRIVACY_SCHEDULE_SUCCESS]:
    fetchChargePointPrivacyScheduleSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_PRIVACY_SCHEDULE_FAIL]:
    fetchChargePointPrivacyScheduleFail,
  [ChargePointTypes.DELETE_CHARGE_POINT_PRIVACY_RULES_LOADING]:
    deleteChargePointPrivacyRulesLoading,
  [ChargePointTypes.DELETE_CHARGE_POINT_PRIVACY_RULES_SUCCESS]:
    deleteChargePointPrivacyRulesSuccess,
  [ChargePointTypes.DELETE_CHARGE_POINT_PRIVACY_RULES_FAIL]:
    deleteChargePointPrivacyRulesFail,
  [ChargePointTypes.ADD_CHARGE_POINT_PRIVACY_RULES_LOADING]:
    addChargePointPrivacyRulesLoading,
  [ChargePointTypes.ADD_CHARGE_POINT_PRIVACY_RULES_SUCCESS]:
    addChargePointPrivacyRulesSuccess,
  [ChargePointTypes.ADD_CHARGE_POINT_PRIVACY_RULES_FAIL]:
    addChargePointPrivacyRulesFail,
  [ChargePointTypes.FETCH_CHARGE_POINT_ACCESS_GROUPS_LOADING]:
    fetchChargePointAccessGroupsLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_ACCESS_GROUPS_SUCCESS]:
    fetchChargePointAccessGroupsSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_ACCESS_GROUPS_FAIL]:
    fetchChargePointAccessGroupsFail,
  [ChargePointTypes.CLEAR_CHARGE_POINT_ACCESS_GROUPS]:
    clearChargePointAccessGroups,
  [ChargePointTypes.DELETE_CHARGE_POINT_ACCESS_GROUPS_BULK_LOADING]:
    deleteChargePointAccessGroupsBulkLoading,
  [ChargePointTypes.DELETE_CHARGE_POINT_ACCESS_GROUPS_BULK_SUCCESS]:
    deleteChargePointAccessGroupsBulkSuccess,
  [ChargePointTypes.DELETE_CHARGE_POINT_ACCESS_GROUPS_BULK_FAIL]:
    deleteChargePointAccessGroupsBulkFail,
  [ChargePointTypes.ADD_CHARGE_POINT_ACCESS_GROUPS_BULK_LOADING]:
    addChargePointAccessGroupsBulkLoading,
  [ChargePointTypes.ADD_CHARGE_POINT_ACCESS_GROUPS_BULK_SUCCESS]:
    addChargePointAccessGroupsBulkSuccess,
  [ChargePointTypes.ADD_CHARGE_POINT_ACCESS_GROUPS_BULK_FAIL]:
    addChargePointAccessGroupsBulkFail,
  [ChargePointTypes.FETCH_CHARGE_POINT_TARIFFS_LOADING]:
    fetchChargePointTariffsLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_TARIFFS_SUCCESS]:
    fetchChargePointTariffsSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_TARIFFS_FAIL]:
    fetchChargePointTariffsFail,
  [ChargePointTypes.DELETE_CHARGE_POINT_TARIFFS_LOADING]:
    deleteChargePointTariffsLoading,
  [ChargePointTypes.DELETE_CHARGE_POINT_TARIFFS_SUCCESS]:
    deleteChargePointTariffsSuccess,
  [ChargePointTypes.DELETE_CHARGE_POINT_TARIFFS_FAIL]:
    deleteChargePointTariffsFail,
  [ChargePointTypes.ADD_CHARGE_POINT_TARIFFS_LOADING]:
    addChargePointTariffsLoading,
  [ChargePointTypes.ADD_CHARGE_POINT_TARIFFS_SUCCESS]:
    addChargePointTariffsSuccess,
  [ChargePointTypes.ADD_CHARGE_POINT_TARIFFS_FAIL]: addChargePointTariffsFail,
  [ChargePointTypes.RESET_CHARGE_POINT_SPECIFICATIONS]:
    resetChargePointSpecifications,
  [ChargePointTypes.PREPEND_CHARGE_POINT_LOG_LIST]: prependChargePointLogList,
  [ChargePointTypes.APPEND_BUFFER_CHARGE_POINT_LOG_LIST]:
    appendBufferChargePointLogList,
  [ChargePointTypes.SET_IS_CHARGE_POINT_LOGS_LIVE]: setIsChargePointLogsLive,
  [ChargePointTypes.FETCH_CHARGE_POINT_UPTIME_STATISTICS_LOADING]:
    fetchChargePointUptimeStatisticsLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_UPTIME_STATISTICS_SUCCESS]:
    fetchChargePointUptimeStatisticsSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_UPTIME_STATISTICS_FAIL]:
    fetchChargePointUptimeStatisticsFail,
  [ChargePointTypes.SET_CHARGE_POINT_STATISTICS_FILTER]:
    setChargePointStatisticsFilter,
  [ChargePointTypes.FETCH_CONNECTORS_UTILIZATION_FAIL]:
    fetchConnectorsUtilizationFail,
  [ChargePointTypes.FETCH_CONNECTORS_UTILIZATION_LOADING]:
    fetchConnectorsUtilizationLoading,
  [ChargePointTypes.FETCH_CONNECTORS_UTILIZATION_SUCCESS]:
    fetchConnectorsUtilizationSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_SUBSCRIBED_ALERTS_LOADING]:
    fetchChargePointSubscribedAlertsLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_SUBSCRIBED_ALERTS_SUCCESS]:
    fetchChargePointSubscribedAlertsSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_SUBSCRIBED_ALERTS_FAIL]:
    fetchChargePointSubscribedAlertsFail,
  [ChargePointTypes.FETCH_CHARGE_POINT_ALERTS_LOADING]:
    fetchChargePointAlertsLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_ALERTS_SUCCESS]:
    fetchChargePointAlertsSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_ALERTS_FAIL]: fetchChargePointAlertsFail,
  [ChargePointTypes.UPDATE_CHARGE_POINT_ALERTS_LOADING]:
    updateChargePointAlertsLoading,
  [ChargePointTypes.UPDATE_CHARGE_POINT_ALERTS_SUCCESS]:
    updateChargePointAlertsSuccess,
  [ChargePointTypes.UPDATE_CHARGE_POINT_ALERTS_FAIL]:
    updateChargePointAlertsFail,
  [ChargePointTypes.FETCH_CHARGE_POINT_LOCAL_LIST_LOADING]:
    fetchChargePointLocalListLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_LOCAL_LIST_SUCCESS]:
    fetchChargePointLocalListSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_LOCAL_LIST_FAIL]:
    fetchChargePointLocalListFail,
  [ChargePointTypes.UPDATE_CHARGE_POINT_LOCAL_LIST_LOADING]:
    updateChargePointLocalListLoading,
  [ChargePointTypes.UPDATE_CHARGE_POINT_LOCAL_LIST_SUCCESS]:
    updateChargePointLocalListSuccess,
  [ChargePointTypes.UPDATE_CHARGE_POINT_LOCAL_LIST_FAIL]:
    updateChargePointLocalListFail,
  [ChargePointTypes.FETCH_CHARGE_POINT_CHARGING_PROFILES_LOADING]:
    fetchChargePointChargingProfilesLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_CHARGING_PROFILES_SUCCESS]:
    fetchChargePointChargingProfilesSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_CHARGING_PROFILES_FAIL]:
    fetchChargePointChargingProfilesFail,
  [ChargePointTypes.FETCH_CHARGE_POINT_COMPOSITE_SCHEDULE_LOADING]:
    fetchChargePointCompositeScheduleLoading,
  [ChargePointTypes.FETCH_CHARGE_POINT_COMPOSITE_SCHEDULE_SUCCESS]:
    fetchChargePointCompositeScheduleSuccess,
  [ChargePointTypes.FETCH_CHARGE_POINT_COMPOSITE_SCHEDULE_FAIL]:
    fetchChargePointCompositeScheduleFail,
  [ChargePointTypes.CLEAR_CHARGE_POINT_CHARGING_PROFILE_LOADING]:
    clearChargePointChargingProfileLoading,
  [ChargePointTypes.CLEAR_CHARGE_POINT_CHARGING_PROFILE_SUCCESS]:
    clearChargePointChargingProfileSuccess,
  [ChargePointTypes.CLEAR_CHARGE_POINT_CHARGING_PROFILE_FAIL]:
    clearChargePointChargingProfileFail,
  [ChargePointTypes.SET_CHARGE_POINT_CHARGING_PROFILE_LOADING]:
    setChargePointChargingProfileLoading,
  [ChargePointTypes.SET_CHARGE_POINT_CHARGING_PROFILE_SUCCESS]:
    setChargePointChargingProfileSuccess,
  [ChargePointTypes.SET_CHARGE_POINT_CHARGING_PROFILE_FAIL]:
    setChargePointChargingProfileFail,
  [ChargePointTypes.CREATE_CHARGE_POINT_CHARGING_PROFILE_LOADING]:
    createChargePointChargingProfileLoading,
  [ChargePointTypes.CREATE_CHARGE_POINT_CHARGING_PROFILE_SUCCESS]:
    createChargePointChargingProfileSuccess,
  [ChargePointTypes.CREATE_CHARGE_POINT_CHARGING_PROFILE_FAIL]:
    createChargePointChargingProfileFail,
  [ChargePointTypes.FETCH_CONNECTOR_TYPES_LOADING]: fetchConnectorTypesLoading,
  [ChargePointTypes.FETCH_CONNECTOR_TYPES_SUCCESS]: fetchConnectorTypesSuccess,
  [ChargePointTypes.FETCH_CONNECTOR_TYPES_FAIL]: fetchConnectorTypesFail,
  [ChargePointTypes.FETCH_CHARGING_SESSION_LOGS_LOADING]:
    fetchChargingSessionLogsLoading,
  [ChargePointTypes.FETCH_CHARGING_SESSION_LOGS_LOADING_MORE]:
    fetchChargingSessionLogsLoadingMore,
  [ChargePointTypes.FETCH_CHARGING_SESSION_LOGS_SUCCESS]:
    fetchChargingSessionLogsSuccess,
  [ChargePointTypes.FETCH_CHARGING_SESSION_LOGS_FAIL]:
    fetchChargingSessionLogsFail,
  [ChargePointTypes.PREPEND_CHARGING_SESSION_LOG_LIST]:
    prependChargingSessionLogList,
  [ChargePointTypes.APPEND_BUFFER_CHARGING_SESSION_LOG_LIST]:
    appendBufferChargingSessionLogList,
  [ChargePointTypes.SET_CHARGING_SESSION_LOG_PAGINATION_OFFSET]:
    setChargingSessionLogPaginationOffset,
  [ChargePointTypes.FETCH_CHARGING_SESSION_DETAILS_LOADING]:
    fetchChargingSessionDetailsLoading,
  [ChargePointTypes.FETCH_CHARGING_SESSION_DETAILS_SUCCESS]:
    fetchChargingSessionDetailsSuccess,
  [ChargePointTypes.FETCH_CHARGING_SESSION_DETAILS_FAIL]:
    fetchChargingSessionDetailsFail,
  [ChargePointTypes.FETCH_CHARGING_SESSION_EVENTS_LOADING]:
    fetchChargingSessionEventsLoading,
  [ChargePointTypes.FETCH_CHARGING_SESSION_EVENTS_SUCCESS]:
    fetchChargingSessionEventsSuccess,
  [ChargePointTypes.FETCH_CHARGING_SESSION_EVENTS_FAIL]:
    fetchChargingSessionEventsFail,
  [ChargePointTypes.RESET_CHARGING_SESSION_EVENTS]: resetChargingSessionEvents,
  [ChargePointTypes.RESET_CHARGING_SESSION_LOGS]: resetChargingSessionLogs,
  [ChargePointTypes.SET_CHARGING_SESSION_LOGS_FILTER]:
    setChargingSessionLogsFilter,
  [ChargePointTypes.RESET_CHARGING_SESSION_LOGS_FILTERS]:
    resetChargingSessionLogsFilters,
  [ChargePointTypes.SET_CHARGING_SESSION_LOGS_PAGINATION_OFFSET]:
    setChargingSessionLogsPaginationOffset,
  [ChargePointTypes.EMITTER_UPDATE_CHARGING_EVENTS]:
    emitterUpdateChargingEvents,
  [ChargePointTypes.EMITTER_UPDATE_CHARGING_SESSION_DETAILS]:
    emitterUpdateChargingSessionDetails,
  [ChargePointTypes.SET_IS_CHARGING_ANALYTICS_LIVE]: setIsChargingAnalyticsLive,
  [ChargePointTypes.RESET_CHARGING_SESSION_DETAILS]:
    resetChargingSessionDetails,
  [ChargePointTypes.REVERSE_TRANSACTION_LOADING]: reverseTransactionLoading,
  [ChargePointTypes.REVERSE_TRANSACTION_SUCCESS]: reverseTransactionSuccess,
  [ChargePointTypes.REVERSE_TRANSACTION_FAIL]: reverseTransactionFail,
  [ChargePointTypes.BLOCK_CHARGE_POINT_LOADING]: blockChargePointLoading,
  [ChargePointTypes.BLOCK_CHARGE_POINT_SUCCESS]: blockChargePointSuccess,
  [ChargePointTypes.BLOCK_CHARGE_POINT_FAIL]: blockChargePointFail,
})
